/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('componentEditorRestApiSource', [
  '$location',

  function ($location) {
    return {
      controller: 'ComponentEditorRestApiSourceController',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./_component-editor-rest-api-source.html'),

      replace: true,

      link(scope, element, attrs) {},
    };
  },
]);
